<template>
  <div id="listWidget" class="mb-4">
    <div class="instruction-card card-item mb-3">
      <div class="instruction-header">
        <i class="fa-solid fa-list-ol me-2 text-primary"></i>
        <span class="instruction-title">전동블라인드 확인</span>
      </div>
      <div class="instruction-body">
        <div class="instruction-step">
          <div class="step-number">1</div>
          <div class="step-content">
            <span>등록 버튼을 누르면 전동블라인드 등록 대기 상태가 됩니다.</span>
          </div>
        </div>
        <div class="instruction-step">
          <div class="step-number">2</div>
          <div class="step-content">
            <span>전동모터의 셋팅 버튼을 3번 연속으로 누르면 자동으로 감지하여 등록합니다.</span>
          </div>
        </div>
        <div class="instruction-step">
          <div class="step-number">3</div>
          <div class="step-content">
            <span>등록된 M11, M31 제어기가 없으면 제어기를 먼저 등록해주세요.</span>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col" />
      <div class="col" />
      <div class="col">
        <button type="button" class="btn btn-primary btn-lg" style="width: 100%" @click="onMotorBlindRegistClick">
          등록
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, getCurrentInstance, onBeforeUnmount, ref, watch } from 'vue';
import { useStore } from 'vuex';

const props = defineProps(['handleNextStep']);
const { emitter } = getCurrentInstance().appContext.config.globalProperties;
const store = useStore();

const controllers = computed(() => store.getters['home/getCurrentZoneControllers']);
const ronoSettingDevice = computed(() => store.state.home?.rono?.settingDevice);
const motorBlindRegistTimeoutId = ref(null);

const clearMotorBlindRegistTimeout = () => {
  if (motorBlindRegistTimeoutId.value != null) {
    clearTimeout(motorBlindRegistTimeoutId.value);
    motorBlindRegistTimeoutId.value = null;
    emitter.emit('hideLoading');
  }
};

watch(ronoSettingDevice, (next, prev) => {
  if (!prev && next) {
    clearMotorBlindRegistTimeout();
    props.handleNextStep({
      serialCode: next.serial,
      mode: 'm11_m31',
    });
  }
});

const onMotorBlindRegistClick = () => {
  const hasM11OrM31 = controllers.value?.some((c) => c?.model === 'M11' || c?.model === 'M31');
  if (!hasM11OrM31) {
    emitter.emit('showPopAlert', {
      description: 'M11, M31 제어기가 등록되어 있지 않습니다.\n제어기를 먼저 등록해주세요.',
    });
    return;
  }

  clearMotorBlindRegistTimeout();
  emitter.emit('showLoading');
  store.commit('home/setOnRono', true);

  motorBlindRegistTimeoutId.value = setTimeout(() => {
    motorBlindRegistTimeoutId.value = null;
    emitter.emit('hideLoading');
    store.commit('home/clearRono');
    emitter.emit('showPopAlert', {
      description: '전동모터 등록에 실패했습니다.',
    });
  }, 30000);
};

onBeforeUnmount(() => {
  clearMotorBlindRegistTimeout();
});
</script>

<style scoped>
.instruction-card {
  background-color: #ffffff;
  border: 1px solid #e9ecef;
  border-radius: 1.2rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}

.instruction-header {
  display: flex;
  align-items: center;
  padding: 0.75rem 1rem;
  background-color: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
}

.instruction-title {
  font-size: 0.9rem;
  font-weight: 600;
  color: #212529;
}

.instruction-body {
  padding: 0.75rem 1rem;
}

.instruction-step {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  margin-bottom: 0.75rem;
}

.instruction-step:last-child {
  margin-bottom: 0;
}

.step-number {
  width: 1.5rem;
  height: 1.5rem;
  min-width: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #0d6efd;
  color: white;
  border-radius: 50%;
  font-weight: 600;
  font-size: 0.75rem;
}

.step-content {
  flex: 1;
  padding-top: 0.1rem;
  font-size: 0.85rem;
  line-height: 1.5;
  color: #495057;
}
</style>
